var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1857_1974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.226 4.755C23.2219 4.743 23.2189 4.73138 23.2136 4.71975C23.1954 4.67895 23.17 4.64174 23.1386 4.60988L19.3886 0.859875C19.3567 0.82849 19.3193 0.803088 19.2784 0.784875C19.2671 0.78 19.2563 0.777 19.2446 0.772875C19.2126 0.761715 19.1791 0.75515 19.1453 0.753375C19.1393 0.75375 19.1325 0.75 19.125 0.75H8.625C8.52554 0.75 8.43016 0.789509 8.35983 0.859835C8.28951 0.930161 8.25 1.02554 8.25 1.125V8.25H9V1.5H18.75V4.875C18.75 4.97446 18.7895 5.06984 18.8598 5.14016C18.9302 5.21049 19.0255 5.25 19.125 5.25H22.5V20.25H14.625V21H22.875C22.9745 21 23.0698 20.9605 23.1402 20.8902C23.2105 20.8198 23.25 20.7245 23.25 20.625V4.875C23.25 4.86675 23.2459 4.85963 23.2451 4.85138C23.2433 4.81852 23.2368 4.78608 23.226 4.755ZM19.5 4.5V2.03025L21.9697 4.5H19.5Z",
    fill: "url(#paint0_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.96875 23.25H13.0312C13.2576 23.25 13.4795 23.187 13.672 23.068C13.8645 22.949 14.0201 22.7787 14.1213 22.5763C14.2226 22.3739 14.2654 22.1472 14.2451 21.9218C14.2247 21.6964 14.1421 21.4811 14.0062 21.3L13.125 20.1251V15.8325C13.13 14.8468 12.8217 13.8849 12.2444 13.0858C11.6672 12.2868 10.8509 11.6918 9.9135 11.3869L10.8375 9.54263C10.8661 9.4853 10.8796 9.42159 10.8766 9.35757C10.8737 9.29355 10.8543 9.23136 10.8205 9.17694C10.7866 9.12252 10.7394 9.07769 10.6833 9.04671C10.6272 9.01573 10.5641 8.99965 10.5 9.00001H4.5C4.43607 8.99998 4.3732 9.01629 4.31735 9.0474C4.2615 9.07851 4.21453 9.12337 4.1809 9.17774C4.14727 9.23211 4.1281 9.29418 4.12521 9.35804C4.12232 9.4219 4.1358 9.48544 4.16438 9.54263L5.0865 11.3869C4.14909 11.6918 3.33284 12.2868 2.75559 13.0858C2.17835 13.8849 1.86998 14.8468 1.875 15.8325V20.1251L0.993751 21.3C0.857949 21.4811 0.775251 21.6964 0.754925 21.9218C0.734599 22.1472 0.777447 22.3739 0.878667 22.5763C0.979888 22.7787 1.13548 22.949 1.32802 23.068C1.52055 23.187 1.74241 23.25 1.96875 23.25ZM9.89325 9.75001L9.14325 11.25H5.85675L5.10675 9.75001H9.89325ZM1.59375 21.75L2.55 20.475C2.59868 20.4101 2.625 20.3311 2.625 20.25V15.8325C2.6206 14.943 2.91958 14.0785 3.47261 13.3818C4.02564 12.685 4.79968 12.1976 5.667 12H9.333C10.2003 12.1976 10.9744 12.685 11.5274 13.3818C12.0804 14.0785 12.3794 14.943 12.375 15.8325V20.25C12.375 20.3311 12.4013 20.4101 12.45 20.475L13.4062 21.75C13.4585 21.8196 13.4903 21.9025 13.4981 21.9892C13.5059 22.0759 13.4894 22.163 13.4505 22.2409C13.4116 22.3187 13.3517 22.3842 13.2777 22.43C13.2036 22.4758 13.1183 22.5 13.0312 22.5H1.96875C1.8817 22.5 1.79637 22.4758 1.72231 22.43C1.64826 22.3842 1.58842 22.3187 1.54949 22.2409C1.51056 22.163 1.49408 22.0759 1.50189 21.9892C1.50971 21.9025 1.54152 21.8196 1.59375 21.75Z",
    fill: "url(#paint1_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 17.625H8.0625C8.21168 17.625 8.35476 17.6843 8.46025 17.7898C8.56574 17.8952 8.625 18.0383 8.625 18.1875C8.625 18.3367 8.56574 18.4798 8.46025 18.5852C8.35476 18.6907 8.21168 18.75 8.0625 18.75H6V19.5H7.125V20.25H7.875V19.5H8.0625C8.4106 19.5 8.74444 19.3617 8.99058 19.1156C9.23672 18.8694 9.375 18.5356 9.375 18.1875C9.375 17.8394 9.23672 17.5056 8.99058 17.2594C8.74444 17.0133 8.4106 16.875 8.0625 16.875H6.9375C6.78832 16.875 6.64524 16.8157 6.53975 16.7102C6.43426 16.6048 6.375 16.4617 6.375 16.3125C6.375 16.1633 6.43426 16.0202 6.53975 15.9148C6.64524 15.8093 6.78832 15.75 6.9375 15.75H9V15H7.875V14.25H7.125V15H6.9375C6.5894 15 6.25556 15.1383 6.00942 15.3844C5.76328 15.6306 5.625 15.9644 5.625 16.3125C5.625 16.6606 5.76328 16.9944 6.00942 17.2406C6.25556 17.4867 6.5894 17.625 6.9375 17.625Z",
    fill: "url(#paint2_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.375 3.375C14.7261 3.37363 14.0949 3.16324 13.575 2.775L12.975 2.325C12.9101 2.27632 12.8311 2.25 12.75 2.25C12.6689 2.25 12.5899 2.27632 12.525 2.325L11.925 2.775C11.4051 3.16324 10.7739 3.37363 10.125 3.375C10.0255 3.375 9.93016 3.41451 9.85983 3.48484C9.78951 3.55516 9.75 3.65054 9.75 3.75V5.81925C9.75037 6.28216 9.87284 6.73678 10.1051 7.13722C10.3373 7.53767 10.671 7.86977 11.0726 8.1L12.5625 8.9505C12.6191 8.98286 12.6833 8.99988 12.7485 8.99988C12.8137 8.99988 12.8779 8.98286 12.9345 8.9505L14.4274 8.1C14.829 7.86977 15.1627 7.53767 15.3949 7.13722C15.6272 6.73678 15.7496 6.28216 15.75 5.81925V3.75C15.75 3.65054 15.7105 3.55516 15.6402 3.48484C15.5698 3.41451 15.4745 3.375 15.375 3.375ZM15 5.81925C14.9996 6.14969 14.9121 6.47419 14.7462 6.76C14.5804 7.04581 14.3421 7.28283 14.0554 7.44712L12.75 8.193L11.4446 7.44712C11.1579 7.28283 10.9196 7.04581 10.7538 6.76C10.5879 6.47419 10.5004 6.14969 10.5 5.81925V4.10588C11.1796 4.03617 11.8275 3.78359 12.375 3.375L12.75 3.09375L13.125 3.375C13.6725 3.78359 14.3204 4.03617 15 4.10588V5.81925Z",
    fill: "url(#paint3_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 4.125H12.375V4.875H13.125V4.125Z",
    fill: "url(#paint4_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 6.375H12.375V7.125H13.125V6.375Z",
    fill: "url(#paint5_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.21875H11.25V5.96875H12V5.21875Z",
    fill: "url(#paint6_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 5.25H13.5V6H14.25V5.25Z",
    fill: "url(#paint7_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10.125H11.625V10.875H21V10.125Z",
    fill: "url(#paint8_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 12H13.125V12.75H16.875V12Z",
    fill: "url(#paint9_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12H17.625V12.75H21V12Z",
    fill: "url(#paint10_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 13.875H14.25V14.625H21V13.875Z",
    fill: "url(#paint11_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375 15.75H14.25V16.5H18.375V15.75Z",
    fill: "url(#paint12_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15.75H19.125V16.5H21V15.75Z",
    fill: "url(#paint13_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17.625H14.25V18.375H21V17.625Z",
    fill: "url(#paint14_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 8.25H17.25V9H21V8.25Z",
    fill: "url(#paint15_linear_1857_1974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6.375H17.25V7.125H21V6.375Z",
    fill: "url(#paint16_linear_1857_1974)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1857_1974",
    x1: 4.67045,
    y1: -3.20669,
    x2: 24.4068,
    y2: -1.33707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1857_1974",
    x1: -2.47159,
    y1: 6.21566,
    x2: 15.1913,
    y2: 8.35559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1857_1974",
    x1: 4.73011,
    y1: 13.0776,
    x2: 9.67689,
    y2: 13.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1857_1974",
    x1: 8.31818,
    y1: 0.931128,
    x2: 16.182,
    y2: 1.82506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1857_1974",
    x1: 12.196,
    y1: 3.97846,
    x2: 13.1757,
    y2: 4.10374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1857_1974",
    x1: 12.196,
    y1: 6.22846,
    x2: 13.1757,
    y2: 6.35374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1857_1974",
    x1: 11.071,
    y1: 5.07221,
    x2: 12.0507,
    y2: 5.19749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1857_1974",
    x1: 13.321,
    y1: 5.10346,
    x2: 14.3007,
    y2: 5.22874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1857_1974",
    x1: 9.38778,
    y1: 9.97846,
    x2: 12.8884,
    y2: 15.5743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1857_1974",
    x1: 12.2301,
    y1: 11.8535,
    x2: 15.7637,
    y2: 14.1129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1857_1974",
    x1: 16.8196,
    y1: 11.8535,
    x2: 20.1854,
    y2: 13.7904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1857_1974",
    x1: 12.6392,
    y1: 13.7285,
    x2: 16.4939,
    y2: 18.1651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1857_1974",
    x1: 13.2656,
    y1: 15.6035,
    x2: 16.9293,
    y2: 18.1804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1857_1974",
    x1: 18.6776,
    y1: 15.6035,
    x2: 20.9359,
    y2: 16.3255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1857_1974",
    x1: 12.6392,
    y1: 17.4785,
    x2: 16.4939,
    y2: 21.9151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1857_1974",
    x1: 16.3551,
    y1: 8.10346,
    x2: 19.8887,
    y2: 10.3629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1857_1974",
    x1: 16.3551,
    y1: 6.22846,
    x2: 19.8887,
    y2: 8.48793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1857_1974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.bd66fb2cb73d787067f898647c43131e.svg";
export { ForwardRef as ReactComponent };